export default __webpack_public_path__ + "static/in-person-lessons-46048ef2aaca6dd6466996afc2601735.jpg";